import * as React from 'react';

import {
  Button,
  cn,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@rematter/ui-web';
import { XCircle } from 'lucide-react';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type ContainerVoidDialogProps = {
  containerId: string;
  onVoid: (containerId: string) => Promise<void>;
  onCancel?: () => void;
};

export const ContainerVoidDialog: React.FC<ContainerVoidDialogProps> = ({
  containerId,
  onVoid,
  onCancel,
}) => {
  const t = useTranslations();
  const [isLoading, setIsLoading] = React.useState(false);

  const title = t.containersView.voidDialog.title;
  const message = t.containersView.voidDialog.message;
  const confirmLabel = t.containersView.voidDialog.confirm;
  const cancelLabel = t.containersView.voidDialog.cancel;

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onVoid(containerId);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogOverlay isOpen className={cn('@ContainerVoidDialog')}>
      <DialogContent>
        <DialogHeader>
          <div className="text-base font-semibold">{title}</div>
        </DialogHeader>
        <div className="flex flex-col gap-2 px-4">
          <div className="text-base text-neutral/50">{message}</div>
          <div className="flex justify-end gap-2 py-4">
            <Button
              variant="text"
              color="neutral"
              onPress={onCancel}
              isDisabled={isLoading}
            >
              {cancelLabel}
            </Button>
            <Button
              variant="solid"
              color="failure"
              onPress={handleConfirm}
              isDisabled={isLoading}
              icon={<XCircle className="size-4" />}
            >
              {confirmLabel}
            </Button>
          </div>
        </div>
      </DialogContent>
    </DialogOverlay>
  );
};
